import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import AdvanceShareTemplateList from './advance-share-template-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Advance Share Templates">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Advance Shares</Breadcrumb.Item>
            <Breadcrumb.Item active>Templates</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <AdvanceShareTemplateList />
    </Panel>
  );
};

export default Page;
